import angular from 'angular';
import { default as importDataService } from 'app/services/data/import.data.service';
import importMappingResultDialog from './importMappingResultDialog';
import controller from './import-mapping-dialog.controller';
import template from './import-mapping-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
  ssDialogService,
} = library;

export class dialogService {
  getOptions({
    customerId = -1, importSet = null, title = '', refreshCallBack
  }) {
    return {
      controller,
      controllerAs: 'importMappingsDialogVM',
      locals: {
        customerId,
        importSet,
        title,
        refreshCallBack
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.global.importDocument.importMappingDialog', [
  alerts,
  importDataService,
  importMappingResultDialog,
  loaderService,
  ssDialogService,
])
  .service('importMappingDialog', dialogService)
  .name;

console.log('app.components.global.importDocument.importMappingDialog created');
